import { createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment/moment";
import { setBudgetDetailsDrawerAccumulatedCostDate } from "@/store/budgets/budgetsSlice";
import { getBudgetDetailsByBudgetIdThunk } from "@/store/budgets/thunks/drawer/getBudgetDetailsByBudgetIdThunk";
import { getBudgetDetailsAccumulatedCostByBudgetIdAndDateThunk } from "@/store/budgets/thunks/drawer/getBudgetDetailsAccumulatedCostByBudgetIdAndDateThunk";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

import { RootState } from "@/store/store";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { getFQuarterByStartMonth } from "@/components/common/date-range-picker/utils/preDefinedRanges/getQuarterlyPreDefinedRange";

export const initiateBudgetsDetailsDrawerThunk = createAsyncThunk(
  "budgets/initiateBudgetsDetailsDrawer",
  async (_, { dispatch, getState }) => {
    const state = getState() as RootState;
    const quarterStartMonth = organisationQuarterStartMonthSelector(state);

    const res = await dispatch(getBudgetDetailsByBudgetIdThunk()).unwrap();
    const period = res?.period ?? "monthly";
    const startDate = moment(res?.start_date);

    if (period === "daily" || startDate.isAfter(moment())) {
      return;
    }

    let dateToSet = res?.start_date;

    if (period === "quarterly") {
      const currentDate = moment();
      const currentMonth = currentDate.month() + 1;
      const { start: quarterStart } = getFQuarterByStartMonth(
        currentMonth + 1,
        quarterStartMonth,
      );

      currentDate.set({
        year: currentDate.year(),
        month: moment(quarterStart).month(),
        date: 1,
      });

      dateToSet = formatDate(moment(currentDate), {
        type: "yearMonthDay",
      });
    }

    if (period === "monthly") {
      dateToSet = formatDate(moment().startOf("month"), {
        type: "yearMonthDay",
      });
    }

    if (period === "annually") {
      dateToSet = formatDate(moment().startOf("year"), {
        type: "yearMonthDay",
      });
    }

    if (!dateToSet) {
      return;
    }

    dispatch(setBudgetDetailsDrawerAccumulatedCostDate(dateToSet));
    dispatch(getBudgetDetailsAccumulatedCostByBudgetIdAndDateThunk());
  },
);
